document.addEventListener('DOMContentLoaded', () => {
  const numbers = document.querySelectorAll('.animation--number');

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;

        const match = el.textContent.trim().match(/^([+-]?\s*\d+(?:[.,]\d+)?)/);
        if (!match) return;

        const rawValue = match[1].trim();
        const hasComma = rawValue.includes(',');
        const compact = rawValue.replace(/\s+/g, '');

        const isNegative = compact.startsWith('-');
        const isPositive = compact.startsWith('+');

        const decimalMatch = compact.match(/[.,](\d+)/);
        const decimals = decimalMatch ? decimalMatch[1].length : 0;

        const numericPortion = compact.replace(/[+-]/, '').replace(',', '.');
        const finalNumber = parseFloat(numericPortion);
        const duration = 1600;

        const sign = isNegative ? '-' : isPositive ? '+' : '';

        const formatNumber = (value) => {
          const str = decimals > 0 ? Number(value).toFixed(decimals) : String(Math.floor(value));
          return hasComma ? str.replace('.', ',') : str;
        };

        el.textContent = sign + formatNumber(0) + '%';

        setTimeout(() => {
          const startTime = performance.now();

          function animate(time) {
            const progress = Math.min((time - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);

            const currentValue = eased * finalNumber;
            const current = formatNumber(currentValue);

            el.textContent = sign + current + '%';

            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              el.textContent = sign + (hasComma ? numericPortion.replace('.', ',') : numericPortion) + '%';
            }
          }

          requestAnimationFrame(animate);
        }, 500);

        obs.unobserve(el);
      });
    },
    { threshold: 0.5 }
  );

  numbers.forEach((el) => observer.observe(el));
});
